import css from "./NpcsBlock.module.css";

import { Link } from "react-router";
import { Icon } from "../ui/Icon";
import { useRealm, useT, useTurl } from "~/util/Lang";
import { Heading2 } from "../ui/Heading";

export function NpcsBlock() {
  const turl = useTurl();
  const t = useT();
  const { game } = useRealm();

  let bosses = bossesC1;
  switch (game) {
    case "c1":
      bosses = bossesC1;
      break;
    case "c2":
    case "c3":
      bosses = bossesC2;
      break;
    case "c4":
    case "c5":
    case "il":
    case "gf":
      bosses = bossesC4;
      break;
  }
  return (
    <>
      <Heading2>{t({ en: "NPCs", ru: "Мобы" })}</Heading2>
      <div className="columns">
        <div className="column">
          <h3 className={css.heading}>{t({ en: "Races", ru: "Расы" })}</h3>
          <ul className={css.list}>
            {races.map((race, i) => (
              <li className={css.item} key={i}>
                <div className={css.title}>
                  <Icon icon={race.icon} size={16} />
                  <Link to={turl(`/npcs?f=${race.type}`)}>{t(race.name)}</Link>
                </div>
                {/* <div className={css.levelLine}>
                {levels.map((level, i) => (
                  <Link
                    className={css.levelButton}
                    to={turl(`/npcs?f=${race.type};${level.type}`)}
                    key={i}
                  >
                    {level.name}
                  </Link>
                ))}
              </div> */}
              </li>
            ))}
          </ul>
        </div>
        <div className="column">
          <h3 className={css.heading}>
            {t({ en: "Epic Bosses", ru: "Эпические боссы" })}
          </h3>
          <ul className={css.list}>
            {bosses.map((boss, i) => (
              <li className={css.item} key={i}>
                <div className={css.title}>
                  <Icon icon={boss.icon} size={16} />
                  <Link to={turl(`/npcs/${boss.path}`)}>{t(boss.name)}</Link>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
}

const races = [
  {
    name: { en: "Animals", ru: "Животные" },
    icon: "skill4293",
    type: "race:animal",
  },
  {
    name: { en: "Beasts", ru: "Звери" },
    icon: "skill4292",
    type: "race:beast",
  },
  { name: { en: "Bugs", ru: "Жуки" }, icon: "skill4301", type: "race:bug" },
  {
    name: { en: "Constructs", ru: "Создания" },
    icon: "skill4291",
    type: "race:construct",
  },
  {
    name: { en: "Demonic", ru: "Демоны" },
    icon: "skill4298",
    type: "race:demonic",
  },
  // { name: "Divine", icon: "", type: "" },
  {
    name: { en: "Dragons", ru: "Драконы" },
    icon: "skill4299",
    type: "race:dragon",
  },
  {
    name: { en: "Elementals", ru: "Элементали" },
    icon: "skill4296",
    type: "race:elemental",
  },
  { name: { en: "Fairies", ru: "Феи" }, icon: "skill4302", type: "race:fairy" },
  // { name: "Giant", icon: "", type: "" },
  {
    name: { en: "Humanoids", ru: "Гуманоиды" },
    icon: "skill4295",
    type: "race:humanoid",
  },
  {
    name: { en: "Plants", ru: "Растения" },
    icon: "skill4294",
    type: "race:plant",
  },
  {
    name: { en: "Undead", ru: "Нежить" },
    icon: "skill4290",
    type: "race:undead",
  },
  // { name: "Etc", icon: "", type: "" },
];

const levels = [
  { name: "1+", type: "min:1;max:9&s=lvl" },
  { name: "10+", type: "min:10;max:19&s=lvl" },
  { name: "20+", type: "min:20;max:29&s=lvl" },
  { name: "30+", type: "min:30;max:39&s=lvl" },
  { name: "40+", type: "min:40;max:49&s=lvl" },
  { name: "50+", type: "min:50;max:59&s=lvl" },
  { name: "60+", type: "min:60;max:69&s=lvl" },
  { name: "70+", type: "min:70;max:79&s=lvl" },
];

const bossesC1 = [
  {
    name: { en: "Queen Ant", ru: "Королева Муравьев" },
    icon: "skill4301",
    path: "queen_ant",
  },
  { name: { en: "Core", ru: "Ядро" }, icon: "skill4291", path: "core" },
  { name: { en: "Orfen", ru: "Орфен" }, icon: "skill4296", path: "orfen" },
  {
    name: { en: "Antharas", ru: "Антарас" },
    icon: "skill4299",
    path: "antaras",
  },
];
const bossesC2 = [
  ...bossesC1,
  { name: { en: "Zaken", ru: "Закен" }, icon: "skill4290", path: "zaken" },
  { name: { en: "Baium", ru: "Баюм" }, icon: "skill4291", path: "baium" },
];

const bossesC4 = [
  ...bossesC2,
  {
    name: { en: "Valakas", ru: "Валакас" },
    icon: "skill4299",
    path: "valakas",
  },
];
